import React from 'react'
import Checkbox from '../basecheckbox/Checkbox';
import styles from "./CheckboxWLabel.styles"
import Label from '../../label/Label';

const CheckboxWLabel = ({ checked = false, containerCustomStyle={}, appendRequiredStar = false, label = "", onChangeCb = () => { }, weight, name = "", iconName, labelCustomStyles = {}, disabled, tabIndex="0" }) => {

    return (
        <div style={{ ...styles.checkboxWLabelContainer, ...containerCustomStyle }}>
            <Checkbox name={name} checked={checked} onChangeCb={onChangeCb} iconName={iconName} disabled={disabled} tabIndex={tabIndex} />
            <Label
                customStyles={{ ...styles.checkboxLabel, ...labelCustomStyles }}
                weight={weight}
            >
                {label}
            </Label>
            {
                appendRequiredStar && <span style={styles.requiredStarLabel}>
                    <span title={`${name} is Required`}>*</span>
                </span>
            }
        </div>
    );
}

export default CheckboxWLabel